<template>
    <div class="to-top" v-show="show" @click="toTop">
        <span>返回顶部</span>
    </div>
</template>
<script lang="ts" setup>
import { defineEmits, defineProps } from "vue";

const emits = defineEmits(["toTop"]);
defineProps({
    show: {
        type: Boolean,
        default: false,
    },
});

function toTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    emits("toTop");
}
</script>
<style lang="scss">
$f16: 16px;
.to-top {
    position: fixed;
    right: $f16 * 1.125;
    bottom: $f16 * 1.125;
    width: $f16 * 4;
    height: $f16 * 4;
    padding: $f16;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 0 $f16 * 0.5 #eee;
    cursor: pointer;
    transition: all 0.5s ease-in-out;
    box-sizing: border-box;
    z-index: 99;
    i {
        font-size: $f16 * 1.125;
    }
    span {
        display: inline-block;
        line-height: $f16 * 1.125;
        font-size: $f16 * 0.825;
    }
    &:hover {
        box-shadow: 0 0 $f16 * 1.125 #eee;
    }
}
</style>
